import React, { useEffect, useState } from 'react';
import { Card, Col, Nav, Row, Tab, Offcanvas } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import OrderDetailModal from './OrderDetailModal';
import { useLocation } from 'react-router-dom';
import OrderNotes from './OrderNotes';
import AddPatientModal from './AddPatientModal';
import OrderInternalNotes from './OrderInternalNotes';
import OrderLogs from './OrderLogs';
import OrderHoldDetails from './OrderHoldDetails';

const NavItem = ({ item, classNameCustom }) => {
    return (
        <Nav.Item as="li" className={`${classNameCustom}`}>
            <Nav.Link
                className={`mb-0 py-1 px-1 cursor-pointer`}
                eventKey={item.toLowerCase().replaceAll(" ", "-")}>
                {item}
            </Nav.Link>
        </Nav.Item>
    );
};

const drawerStyles = `
/* Custom Offcanvas styles */
.order-detail-offcanvas {
  width: 40vw !important; /* 30-35% page width */
  min-width: 460px !important;
  max-width: 800px !important;
  border-left: 1px solid rgba(226, 232, 240, 0.8) !important;
  box-shadow: -10px 0 30px rgba(15, 23, 42, 0.15) !important;
  background-color: #ffffff !important;
}

/* Glassmorphism backdrop */
.order-detail-offcanvas-backdrop {
  background-color: rgba(15, 23, 42, 0.3) !important;
  backdrop-filter: blur(4px) !important;
  -webkit-backdrop-filter: blur(4px) !important;
}

/* Header styling */
.order-detail-offcanvas .offcanvas-header {
  padding: 1.25rem 1.5rem !important;
  border-bottom: 1px solid #e2e8f0 !important;
  background-color: #ffffff !important;
}

.order-detail-offcanvas .offcanvas-title {
  font-size: 0.95rem !important;
  font-weight: 700 !important;
  color: #0f172a !important;
}

/* Body container */
.order-detail-offcanvas .offcanvas-body {
  padding: 1.5rem !important;
  background-color: #f8fafc !important;
  overflow-y: hidden !important;
  display: flex !important;
  flex-direction: column !important;
}

/* Ensure flex containers take up the remaining height */
.order-detail-offcanvas .card-body {
  flex: 1 1 auto !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

.order-detail-offcanvas .tab-content-wrapper,
.order-detail-offcanvas .tab-content {
  flex: 1 1 auto !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
}

/* Make active tab-pane a flex column that scrolls naturally */
.order-detail-offcanvas .tab-pane.active {
  flex: 1 1 auto !important;
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}

/* Segmented Control Tabs (Modern UI Design) */
.order-detail-offcanvas .nav-tabs {
  background-color: #f1f5f9 !important;
  border-radius: 10px !important;
  padding: 4px !important;
  border: none !important;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  gap: 2px !important;
  margin-bottom: 1.25rem !important;
}

.order-detail-offcanvas .nav-tabs::-webkit-scrollbar {
  display: none !important;
}

.order-detail-offcanvas .nav-tabs .nav-item {
  flex: 1 1 auto !important;
  text-align: center !important;
  white-space: nowrap !important;
}

.order-detail-offcanvas .nav-tabs .nav-link {
  border: none !important;
  border-radius: 8px !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  color: #64748b !important;
  padding: 6px 12px !important;
  transition: all 0.2s ease !important;
  background-color: transparent !important;
  width: 100% !important;
  margin-bottom: 0 !important;
}

.order-detail-offcanvas .nav-tabs .nav-item .nav-link:hover {
  color: #0f172a !important;
}

.order-detail-offcanvas .nav-tabs .nav-item .nav-link.active {
  background-color: #ffffff !important;
  color: #007bff !important;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08) !important;
}

/* Flatten card layout to remove double borders and padding */
.order-detail-offcanvas .card {
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
  margin-top: 0 !important;
}

.order-detail-offcanvas .card-header {
  background-color: transparent !important;
  border-bottom: none !important;
}

.order-detail-offcanvas .card-body {
  padding: 0 !important;
}

.order-detail-offcanvas .card-footer {
  background-color: transparent !important;
  border-top: none !important;
  padding: 1rem 0 0 0 !important;
}

/* Ensure grid elements are aligned side-by-side instead of stacking */
.order-detail-offcanvas .row {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
  display: flex !important;
  flex-wrap: wrap !important;
}

.order-detail-offcanvas .col-md-6 {
  flex: 0 0 50% !important;
  max-width: 50% !important;
  width: 50% !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.order-detail-offcanvas .col-md-4 {
  flex: 0 0 33.33333% !important;
  max-width: 33.33333% !important;
  width: 33.33333% !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.order-detail-offcanvas .col-md-8 {
  flex: 0 0 66.66667% !important;
  max-width: 66.66667% !important;
  width: 66.66667% !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.order-detail-offcanvas .col-md-9 {
  flex: 0 0 75% !important;
  max-width: 75% !important;
  width: 75% !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.order-detail-offcanvas .col-md-3 {
  flex: 0 0 25% !important;
  max-width: 25% !important;
  width: 25% !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.order-detail-offcanvas .col-xxl-12 {
  flex: 0 0 100% !important;
  max-width: 100% !important;
  width: 100% !important;
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

@media (max-width: 576px) {
  .order-detail-offcanvas {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
  }
  
  .order-detail-offcanvas .col-md-6,
  .order-detail-offcanvas .col-md-4,
  .order-detail-offcanvas .col-md-8,
  .order-detail-offcanvas .col-md-9,
  .order-detail-offcanvas .col-md-3 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
    width: 100% !important;
  }
}
`;

const OrderDetailModalParent = ({ show, filteredData, setRefresh, handleClose, setOrder }) => {
    const [navItems, setNavItems] = useState([]);
    const location = useLocation();
    const state = location?.state?.original;
    const holdReasons = JSON.parse(localStorage.getItem("activeHoldReasonsData") || "[]");

    useEffect(() => {
        let results = ['Order-Details', 'Messaging', 'Logs', 'Internal-Notes'];
        if (state?.rxnumber || state?.rx_number) {
            results.splice(1, 0, 'Hold');
        }
        setNavItems(results);
    }, [state?.rxnumber, state?.rx_number]);

    return (
        <>
            <style>{drawerStyles}</style>

            <Offcanvas
                show={show}
                onHide={() => handleClose(false)}
                placement="end"
                className="order-detail-offcanvas"
                backdropClassName="order-detail-offcanvas-backdrop"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title className="offcanvas-title">
                        Order Detail for {state?.patient}, Task ID: {state?.orderid}
                    </Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="offcanvas-body">
                    <Tab.Container id="audience-tab" defaultActiveKey="order-details">
                        <Card.Header
                            as={Flex}
                            justifyContent="between"
                            alignItems="center"
                            className="p-0 border-bottom patientInfoTabs"
                        >
                            <Nav
                                as="ul"
                                className="nav-tabs border-0 d-flex w-100 flex-nowrap chart-tab tab-active-caret p-0"
                            >
                                {navItems.map(item => (
                                    <NavItem classNameCustom="nav-item text-center" item={item} key={item} />
                                ))}
                            </Nav>
                        </Card.Header>
                        <Card.Body className="p-0 pt-2 d-flex flex-column overflow-hidden flex-grow-1">
                            <div className="tab-content-wrapper flex-grow-1 d-flex flex-column overflow-hidden">
                                <Tab.Content className="flex-grow-1 d-flex flex-column overflow-hidden">
                                    <Tab.Pane unmountOnExit eventKey="order-details" className="h-100 flex-grow-1 overflow-auto">
                                        {state?.ordertype === 9 ? (
                                            <AddPatientModal dataObj={state} handleClose={() => handleClose(false)} setRefreshOrder={setOrder} />
                                        ) : (
                                            <OrderDetailModal dataObj={state} setRefreshOrder={setOrder} handleClose={() => handleClose(false)} />
                                        )}
                                    </Tab.Pane>
                                    <Tab.Pane unmountOnExit eventKey="messaging" className="h-100 flex-grow-1 overflow-auto d-flex flex-column">
                                        <OrderNotes data={state} filteredData={filteredData} setRefresh={setRefresh} />
                                    </Tab.Pane>
                                    <Tab.Pane unmountOnExit eventKey="logs" className="h-100 flex-grow-1 overflow-auto d-flex flex-column">
                                        <OrderLogs logs={state?.order_status_log} />
                                    </Tab.Pane>
                                    <Tab.Pane unmountOnExit eventKey="internal-notes" className="h-100 flex-grow-1 overflow-auto d-flex flex-column">
                                        <OrderInternalNotes data={state} filteredData={filteredData} setRefresh={setRefresh} />
                                    </Tab.Pane>
                                    <Tab.Pane unmountOnExit eventKey="hold" className="h-100 flex-grow-1 overflow-auto">
                                        <OrderHoldDetails dataObj={state} setRefreshOrder={setOrder} handleClose={() => handleClose(false)} holdReasons={holdReasons} />
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </Card.Body>
                    </Tab.Container>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default OrderDetailModalParent;
